/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Trust_Window_Warning_UnderstoodInputs */



/**
* | output |
* | --- |
* | "Understood, continue" |
*
* @param {Chat_Tool_Trust_Window_Warning_UnderstoodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_trust_window_warning_understood = /** @type {((inputs?: Chat_Tool_Trust_Window_Warning_UnderstoodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Trust_Window_Warning_UnderstoodInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verstanden, weiter")
	return /** @type {LocalizedString} */ ("Understood, continue")
});